import { Box } from '@customerio/pluma-components/react';

/** Email-verification step. Placeholder — content lands with the verify step PR. */
export function ConfirmationStep() {
  return <Box data-testid="signup-step-confirmation" />;
}
